import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Input, FormGroup, Label, Row, Col } from 'reactstrap';
import NumberInput from '../../controls/numberInput';
export default class WindGirder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      diameter: '',
      linearFeet: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDiameter = this.handleChange.bind(null, 'diameter');
    this.handleChangeLinearFeet = this.handleChange.bind(null, 'linearFeet');
  }
  handleChange(key, value) {
    const {
      onCalc
    } = this.props;
    this.setState({
      [key]: value
    }, () => {
      const {
        diameter,
        linearFeet
      } = this.state;
      if (diameter !== '' && linearFeet !== '') {
        // Calculate the surface area
        const parsedDiameter = parseFloat(diameter) || 0;
        const total = 3.14 * (parsedDiameter + 10) * linearFeet;

        // If it's a valid value, pass it up
        if (!_.isNaN(total)) {
          onCalc(+total.toFixed(2));
        }
      }
    });
  }
  render() {
    const {
      diameter,
      linearFeet
    } = this.state;
    const {
      result
    } = this.props;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, {
      style: {
        textAlign: 'center',
        marginBottom: '20px'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      sm: 12
    }, /*#__PURE__*/React.createElement("i", null, "3.14 x (Diameter + 10) x FT", /*#__PURE__*/React.createElement("sup", null, "2"), "/Linear FT = Surface Area"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 1
      }
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "Diameter",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeDiameter,
      value: diameter
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(NumberInput, {
      type: "text",
      label: "FT\xB2/Linear FT",
      entity: "AssetCoatingSet",
      field: "surfaceArea",
      onChange: this.handleChangeLinearFeet,
      value: linearFeet
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 4
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "Surface Area"), /*#__PURE__*/React.createElement(Input, {
      type: "text",
      disabled: true,
      value: result || ''
    })))));
  }
}
WindGirder.defaultProps = {
  onCalc: null,
  result: null
};
WindGirder.propTypes = {
  onCalc: PropTypes.func,
  result: PropTypes.number
};